export default "__VITE_ASSET__6f165d9f__"